"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
require("./styles.scss");
const LocationFilterRadio = ({ title, options, optionParamMap, onChange, ignoreLabel, searchParamDefaults }) => {
    const handleChange = (event) => {
        const selectedValue = event.target.value;
        for (const option in optionParamMap) {
            if (option === selectedValue) {
                onChange(optionParamMap[option], 1);
            }
            else {
                onChange(optionParamMap[option], 0);
            }
        }
    };
    const body = (0, react_1.useMemo)(() => {
        return (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "ontario-radios", style: ignoreLabel ? {} : { marginLeft: "0.2rem", marginBottom: "1.5rem" } }, { children: options === null || options === void 0 ? void 0 : options.map((option) => {
                const optionKey = optionParamMap[option];
                let optionValue = false;
                if (searchParamDefaults) {
                    for (const [key, value] of searchParamDefaults) {
                        if (key === optionKey) {
                            optionValue = value === '1';
                        }
                    }
                }
                return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "ontario-radios__item" }, { children: [(0, jsx_runtime_1.jsx)("input", { className: "ontario-radios__input", type: "radio", id: `radio-${optionParamMap[option]}`, name: title, value: option, onChange: handleChange, defaultChecked: optionValue }), (0, jsx_runtime_1.jsx)("label", Object.assign({ className: "ontario-radios__label", htmlFor: `radio-${optionParamMap[option]}` }, { children: option }))] })));
            }) }));
    }, [options]);
    return ignoreLabel ? body : ((0, jsx_runtime_1.jsxs)("fieldset", Object.assign({ className: "ontario-fieldset" }, { children: [(0, jsx_runtime_1.jsx)("legend", Object.assign({ className: "ontario-fieldset__legend" }, { children: title })), body] })));
};
exports.default = LocationFilterRadio;
